import {
  BrowserRouter as Router, Route, Routes,
} from 'react-router-dom';
import { Navigate } from 'react-router';
import { useAtom, Provider } from 'jotai/index';
import UiKit from '../pages/UiKit';
import Wrapper from '../components/Wrapper';
import Home from '../pages/Home';
import PrivacyPolicy from '../pages/PrivacyPolicy';
import PersonalData from '../pages/PersonalData';
import Login from '../pages/Login';
import Registration from '../pages/Registration';
import PasswordRecovery from '../pages/PasswordRecovery';
import Contact from '../pages/Contact';
import Instruction from '../pages/Instruction';
import About from '../pages/About';
import AuthRoutes from './AuthRoutes';
import { isAuthAtom, screenToNavigateWhenAuthAtom } from '../atoms/accountAtoms';
import ProtectedRoutes from './ProtectedRoutes';
import Configurator from '../pages/Configurator';
import ConfigurationDetails from '../components/ConfigurationDetails';
import MyProjects from '../pages/MyProjects';
import Configurations from '../pages/Configurations';
import InterlayerPage from '../pages/InterlayerPage';
import SetNewPassword from '../pages/SetNewPassword';
import { isServerBrokenAtom } from '../atoms/globalAtoms';
import ServerError from '../pages/ServerError';

function Navigation() {
  const [isAuth] = useAtom(isAuthAtom);
  const [isServerBroken] = useAtom(isServerBrokenAtom);
  const [screenToNavigateWhenAuth] = useAtom(screenToNavigateWhenAuthAtom);

  return (
    <Router>
      <Routes>
        <Route
          path="/"
          element={isServerBroken ? <ServerError /> : <Wrapper />}
        >
          <Route element={<AuthRoutes isAuth={isAuth} screenToNavigate={screenToNavigateWhenAuth || '/configurator'} />}>
            <Route path="/login" element={<Login />} />
            <Route path="/registration" element={<Registration />} />
            <Route path="/password" element={<PasswordRecovery />} />
            <Route path="/fast-login" element={<InterlayerPage />} />
            <Route path="/password-recovery" element={<InterlayerPage />} />
          </Route>

          <Route element={<ProtectedRoutes isAuth={isAuth} unAuthorizedFirstScreen="/login" />}>
            <Route path="/configurator" element={<Configurator />} />
            <Route path="/personal" element={<PersonalData />} />
            <Route path="/my-projects" element={<MyProjects />} />
            <Route path="/configurations" element={<Configurations withProject />} />
            <Route path="/configurations-history" element={<Configurations />} />
            <Route path="/set-new-password" element={<SetNewPassword />} />
          </Route>

          <Route path="/admin-fast-login/*" element={<InterlayerPage />} />
          <Route path="/about" element={<About />} />
          <Route path="/instructions" element={<Instruction />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          {/* <Route path="/ui-kit" element={<UiKit />} /> */}
          {/* <Route path="/details" element={<ConfigurationDetails />} /> */}
          <Route path="/" element={<Home />} />
          <Route path="*" element={<Navigate to="/" replace />} />

        </Route>
      </Routes>
    </Router>
  );
}

export default Navigation;
